import {getHomeworkInfo} from './homework-info';
// blocks埋点事件
const staticsEventName = [
    's3_block_workspace_drag',
    's3_block_remove',
    's3_workspace_menu_show',
    's3_block_menu_show',
    's3_block_menu_remove',
    's3_block_value_select',
    's3_block_value_input',
    's3_block_value_checked',
    's3_block_drag2workspace',
    's3_block_embed_attach',
    's3_block_top_attach',
    's3_block_bottom_attach',
    's3_block_upper_centre_attach',
    's3_block_lower_centre_attach',
    's3_block_simuClick',
    's3_block_make',
    's3_toolbox_unselect',
    's3_toolbox_select',
    's3_workspace_menu_arrange',
    's3_workspace_menu_clear',
    's3_workspace_menu_redo',
    's3_workspace_menu_undo',
    's3_workspace_zoomout',
    's3_workspace_zoomin',
    's3_workspace_zoomreset'
];
export default function (workspace){
    const track = (event, param) => {
        const homeworkInfo = getHomeworkInfo();
        param = param ? {block: param} : null;
        ht.track(event, {
            context: {
                courseId: Number(homeworkInfo.courseId),
                unitId: Number(homeworkInfo.unitId),
                lessonId: Number(homeworkInfo.lessonId),
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: param
        });
    };
   
    staticsEventName.forEach(eventName => {
        workspace.addStaticsListener(eventName, arg => {
            track(eventName, arg);
        });
    });
}
